export const CHECKAUTH_SUCCESS = "CHECKAUTH_SUCCESS"
export const SIGN_OUT = "SIGN_OUT"
